import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const ModBioRoutes: RouteBundle = {
  domain: 'modbio',
  routes: [
    {urlPattern: 'aa-monomers/listing', handler: EditorRoutes.aaMonomerList.bind(EditorRoutes)},
    {
      urlPattern: 'aa-monomers/create/helm-library',
      handler: EditorRoutes.aaMonomerCreateFromHELMLibraryPage.bind(EditorRoutes),
    },
    {
      urlPattern: 'aa-monomers/create',
      handler: EditorRoutes.aaMonomerCreateMethodPicker.bind(EditorRoutes),
    },
    {
      urlPattern: 'aa-monomers/view/helm-library',
      handler: EditorRoutes.aaMonomerViewHELMLibraryPage.bind(EditorRoutes),
    },
    {
      urlPattern: 'aa-monomers/edit/:aaMonomerId',
      handler: EditorRoutes.aaMonomerManualEditPage.bind(EditorRoutes),
    },
    {
      urlPattern: 'aa-monomers/view/:aaMonomerId',
      handler: EditorRoutes.aaMonomerReadOnlyPage.bind(EditorRoutes),
    },
    {urlPattern: 'monomers/create', handler: EditorRoutes.monomerCreateMethodPicker.bind(EditorRoutes)},
    {urlPattern: 'monomers', handler: EditorRoutes.monomers.bind(EditorRoutes), legacy: true},
    {
      urlPattern: 'monomers/custom-notations',
      handler: EditorRoutes.monomerCustomNotationsPage.bind(EditorRoutes),
    },
    {
      urlPattern: 'monomers/custom-notations/:vendorSyntaxId',
      handler: EditorRoutes.monomerCustomNotationsPage.bind(EditorRoutes),
    },
    {
      urlPattern: 'monomers/idt-aliases',
      handler: EditorRoutes.monomerIdtAliasesPage.bind(EditorRoutes),
    },
    {
      urlPattern: 'monomers/create/helm-library',
      handler: EditorRoutes.monomerCreateFromHELMLibraryPage.bind(EditorRoutes),
    },
    {
      urlPattern: 'monomers/create/manual',
      handler: EditorRoutes.monomerManualCreationPage.bind(EditorRoutes),
    },
    {
      urlPattern: 'monomers/create/bulk-csv',
      handler: EditorRoutes.monomerCreateFromCSVPage.bind(EditorRoutes),
    },
    {
      urlPattern: 'monomers/view/helm-library',
      handler: EditorRoutes.monomerViewHELMLibraryPage.bind(EditorRoutes),
    },
    {
      urlPattern: 'monomers/:monomerId/edit',
      handler: EditorRoutes.monomerManualEditPage.bind(EditorRoutes),
    },
  ],
};
